import { EditableTextInputItemList } from "./editableTextInputItemList";
import { EditableAgendaTopicItemList } from "./editableAgendaTopicItemList";
import { EditableAgendaLayoutList } from "./editableAgendaLayoutList";
import { EditableMeetList } from "./editableMeetList";
import { EditableUploadList } from "./editableUploadList";
import { EditableSecardItemList } from "./editableSedCardList";
import { EditableSponsorItemList } from "./editableSponsorList";
import { EventPage } from "./eventpage";
import { TextEditor } from "./textEditor";
import { LanguageSelector } from "./languageSelector";
import { SedCards } from "./sedCards";

import "./styles/app.scss"

// ReSharper disable once UnusedLocalImport
import bulmaCollapsible from "@creativebulma/bulma-collapsible";

//import $ from "jquery";
//import "summernote/dist/summernote-lite.min.js";
//import "summernote/dist/summernote-lite.min.css";

console.log('Start ...');

document.addEventListener('DOMContentLoaded', () => { 
    const login = new EventPage();
    login.check();

    const descriptionTextEditor = new TextEditor();
    descriptionTextEditor.init("eventDescriptionEditor", "eventDescriptionEditorInput");

    const descriptionLocalizedTextEditor = new TextEditor();
    descriptionLocalizedTextEditor.init("eventDescriptionEditor-localized", "eventDescriptionEditorInput-localized");

    const registrationDescriptionTextEditor = new TextEditor();
    registrationDescriptionTextEditor.init("eventRegistrationDescriptionEditor", "eventRegistrationDescriptionEditorInput");

    const editableInputList = new EditableTextInputItemList();
    editableInputList.init("eventRegistrationInputFieldList");

    const editableAgendaList = new EditableAgendaTopicItemList();
    editableAgendaList.init("eventAgendaInputFieldList");

    const editableLayoutList = new EditableAgendaLayoutList();
    editableLayoutList.init("eventAgendaLayoutFieldList");

    const editableMeetList = new EditableMeetList();
    editableMeetList.init("editableMeetList");

    const editableUploadList = new EditableUploadList();
    editableUploadList.init("editableUploadList");

    const editableSedcardList = new EditableSecardItemList();
    editableSedcardList.init("eventSedcardFieldList", "addSedcardItemButton");

    const editableSponsorList = new EditableSponsorItemList();
    editableSponsorList.init("eventSponsorFieldList", "addSponsorItemButton");

    const languageSelector = new LanguageSelector();
    languageSelector.init("languageSelectorForm");


    // Return an array of bulmaCollapsible instances (empty if no DOM node found)
    const bulmaCollapsibleInstances = bulmaCollapsible.attach('.is-collapsible');

    // Initialize sed card dialogs
    const sedCards = new SedCards();
    sedCards.init();

    // Loop into instances
    bulmaCollapsibleInstances.forEach(bulmaCollapsibleInstance => {
        // Check if current state is collapsed or not
        console.log(bulmaCollapsibleInstance.collapsed());
    });
});